<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Risk Analysis</h2>
        </div>
        <div class="tile-content">
            <div class="text-muted" v-if="!riskItems.length && !specialRiskItems.length">
                No risk analysis data available.
            </div>
            <template v-else>
                <ul class="list list-group stack-s">
                    <li class="list-item" v-for="item in basicRiskItems">
                        <v-icon class="inline-s no-flex" :icon="item.icon" :class="item.class"/>
                        <span v-if="item.label" v-html="item.label" class="no-flex inline-s"></span>
                        <span>{{item.result}}</span>
                    </li>
                </ul>
                <ul class="list list-group">
                    <li class="list-item" v-for="item in specialRiskItems">
                        <v-icon class="inline-s no-flex" :icon="item.icon" :class="item.class"/>
                        <span>{{item.result}}</span>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form/index';
    import {
        getBillingAddressRisks,
        getDefaultRisks,
        getGatewayRisks,
        getMetadataRisks,
        getPaymentInstrumentRisks,
    } from './risk-factors';

    const specialRiskItems = ['Velocity', 'BillingAddress', 'PaymentCard'];

    export default {
        name: 'risk-analysis',
        components: {vIcon},
        props: {
            model: {
                type: Object,
            },
        },
        computed: {
            riskItems() {
                return [
                    ...getDefaultRisks(this.model),
                    ...getMetadataRisks(this.model.riskMetadata),
                    ...getGatewayRisks(this.model.gateway),
                    ...getBillingAddressRisks({
                        riskMetadata: this.model.riskMetadata,
                        billingAddress: this.model.billingAddress,
                    }),
                    ...getPaymentInstrumentRisks({
                        paymentInstrument: this.model.paymentInstrument,
                        billingAddress: this.model.billingAddress,
                        paymentCard: this.model.paymentCard,
                    }),
                ];
            },
            basicRiskItems() {
                return this.riskItems.filter(
                    Risk => !specialRiskItems.includes(Risk.name),
                ).map(Risk => Risk.getAnalysis());
            },
            specialRiskItems() {
                return this.riskItems.filter(
                    Risk => specialRiskItems.includes(Risk.name),
                ).map(Risk => Risk.getAnalysis());
            },
        },
    };
</script>
